var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('PageTitle',[_vm._v(" "+_vm._s(_vm.$t('배송중 주문'))+" ")]),_c('admin-iframe',{attrs:{"src":_vm.remoteSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }